(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["leaderboard"] = factory();
	else
		root["leaderboard"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/leaderboard/dist";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(10)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(4),
  /* template */
  __webpack_require__(17),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_MainLeaderboard_MainLeaderboard_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_MainLeaderboard_MainLeaderboard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_MainLeaderboard_MainLeaderboard_vue__);
var Vue = window.Vue;
var VueResource = window.VueResource;



Vue.config.ignoredElements = ['ark-leaderboard', 'ark-div', 'ark-lb-tabs', 'ark-lb-tabs-list', 'ark-lb-tabs-item', 'ark-preload', 'ark-table', 'ark-tr', 'ark-td'];

Vue.use(VueResource);
Vue.http.headers.common['X-CDN-Target-Host'] = window.location.hostname;

window.arkWidgetLeaderboard = {
  leaderboardInstance: null,
  Init: function Init(inputData) {
    this.leaderboardInstance = new Vue({
      el: inputData.el,
      data: function data() {
        return {
          config: inputData.config
        };
      },
      template: '<leaderboardWidget :config="config" />',
      components: { leaderboardWidget: __WEBPACK_IMPORTED_MODULE_0__components_MainLeaderboard_MainLeaderboard_vue___default.a }
    });
  },
  refreshLeaderboard: function refreshLeaderboard(data) {
    this.leaderboardInstance.$emit('refreshLeaderboard', data);
  },
  getTableByPeriod: function getTableByPeriod(period) {
    return this.leaderboardInstance.$children[0].leaderboardData[period];
  }
};
/* harmony default export */ __webpack_exports__["default"] = (window.arkWidgetLeaderboard);

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['leaderboardData', 'chosenPeriod', 'emptyLeaderboardText'],
  filters: {
    name: function name(value) {
      if (!value) return '';
      value = value.toString();
      var firstName = void 0;
      var lastName = void 0;
      try {
        firstName = value.split(' ')[0];
        lastName = value.split(' ')[1].charAt(0);
      } catch (error) {
        return value;
      }
      return firstName + ' ' + lastName;
    }
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tabs_Tabs_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tabs_Tabs_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Tabs_Tabs_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LeaderboardContent_LeaderboardContent__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LeaderboardContent_LeaderboardContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__LeaderboardContent_LeaderboardContent__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Tabs: __WEBPACK_IMPORTED_MODULE_0__Tabs_Tabs_vue___default.a, LeaderboardContent: __WEBPACK_IMPORTED_MODULE_1__LeaderboardContent_LeaderboardContent___default.a },
  name: 'leaderboardWidget',
  props: ['config'],
  data: function data() {
    return {
      chosenPeriod: 'today',
      leaderboardData: null
    };
  },

  created: function created() {
    var _this = this;

    // get cached leaderboard on init
    this.$http.get(this.config.apiUrl + '/Leaderboard/Get/' + this.config.externalGameId).then(function (response) {
      _this.leaderboardData = response.body;
    }, function (error) {
      console.log('Error ' + error.status + ' ' + error.statusText + ' leaderboard data');
    });

    // on refresh, getting leaderboard data without cache
    this.$parent.$on('refreshLeaderboard', function (data) {
      if (typeof data === 'undefined') {
        return;
      }
      var shouldUpdate = true;
      // if there is a score, first we calculate, should we refresh leaderboard or not
      if (data.score && _this.leaderboardData && _this.leaderboardData['today']) {
        shouldUpdate = _this.leaderboardData['today'].length && _this.leaderboardData['today'].length === _this.config.usersLimit ? _this.leaderboardData['today'].every(function (elem) {
          return data.score > elem.value;
        }) : true;
      }

      if (shouldUpdate) {
        _this.$http.get(_this.config.apiUrl + '/Leaderboard/GetWithoutCache/' + data.gameId).then(function (response) {
          _this.leaderboardData = response.body;
        }, function (error) {
          console.log('Error ' + error.status + ' ' + error.statusText + ' leaderboard data');
        });
      }
    });
  }
});

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['tabKey', 'tabName', 'chosenPeriod', 'choseTab'],
  data: function data() {
    return {
      testId: 'leaderboard-' + this.tabKey + '-btn',
      leaderboardData: null
    };
  },

  methods: {
    onChoseTab: function onChoseTab() {
      this.choseTab(this.tabKey);
    }
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TabsItem_TabsItem__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TabsItem_TabsItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__TabsItem_TabsItem__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { tabsItem: __WEBPACK_IMPORTED_MODULE_0__TabsItem_TabsItem___default.a },
  props: ['tabs', 'chosenPeriod'],
  methods: {
    choseTab: function choseTab(chosenTab) {
      this.$emit('update:chosenPeriod', chosenTab);
    }
  }
});

/***/ }),
/* 7 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 8 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 9 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 10 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(7)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(3),
  /* template */
  __webpack_require__(14),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(8)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(5),
  /* template */
  __webpack_require__(15),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(9)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(6),
  /* template */
  __webpack_require__(16),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ark-div', {
    staticClass: "ark-leaderboard-content"
  }, [(_vm.leaderboardData[_vm.chosenPeriod].length) ? _c('ark-table', {
    staticClass: "ark-leaderboard-table"
  }, _vm._l((_vm.leaderboardData[_vm.chosenPeriod]), function(user) {
    return _c('ark-tr', {
      key: user.userId,
      staticClass: "ark-leaderboard-table__row",
      attrs: {
        "ark-test-id": "leaderboard-user-row"
      }
    }, [_c('ark-td', {
      staticClass: "ark-leaderboard-table__cell ark-leaderboard-table__place"
    }, [_vm._v(_vm._s(user.rank))]), _vm._v(" "), _c('ark-td', {
      staticClass: "ark-leaderboard-table__cell ark-leaderboard-table__avatar"
    }, [(user.avatarUrl) ? _c('img', {
      attrs: {
        "src": user.avatarUrl
      }
    }) : _c('img', {
      attrs: {
        "src": "http://ams.cdn.arkadiumhosted.com/assets/arena-4/arena/heap/no_avatar.jpg"
      }
    })]), _vm._v(" "), _c('ark-td', {
      staticClass: "ark-leaderboard-table__cell ark-leaderboard-table__name"
    }, [_vm._v(_vm._s(_vm._f("name")(user.userName)))]), _vm._v(" "), _c('ark-td', {
      staticClass: "ark-leaderboard-table__cell ark-leaderboard-table__score"
    }, [_vm._v(_vm._s(user.value))])], 1)
  })) : _c('ark-div', {
    staticClass: "ark-leaderboard-info-text"
  }, [_vm._v(_vm._s(_vm.emptyLeaderboardText))])], 1)
},staticRenderFns: []}

/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ark-lb-tabs-item', {
    class: [_vm.chosenPeriod === _vm.tabKey ? 'ark-active' : '', 'ark-leaderboard-tabs-item'],
    attrs: {
      "ark-test-id": _vm.testId
    },
    on: {
      "click": _vm.onChoseTab
    }
  }, [_vm._v("\n  " + _vm._s(_vm.tabName) + "\n")])
},staticRenderFns: []}

/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ark-lb-tabs', {
    staticClass: "ark-leaderboard-tabs"
  }, [_c('ark-lb-tabs-list', {
    staticClass: "ark-leaderboard-tabs__list"
  }, _vm._l((_vm.tabs), function(tabName, tabKey) {
    return _c('tabs-item', {
      key: tabKey,
      attrs: {
        "tabName": tabName,
        "tabKey": tabKey,
        "chosenPeriod": _vm.chosenPeriod,
        "choseTab": _vm.choseTab
      }
    })
  }))], 1)
},staticRenderFns: []}

/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ark-leaderboard', {
    staticClass: "ark-leaderboard",
    attrs: {
      "ark-test-id": "leaderboard-widget"
    }
  }, [_c('tabs', {
    attrs: {
      "tabs": _vm.config.tabs,
      "chosenPeriod": _vm.chosenPeriod
    },
    on: {
      "update:chosenPeriod": function($event) {
        _vm.chosenPeriod = $event
      }
    }
  }), _vm._v(" "), _c('ark-div', {
    staticClass: "ark-leaderboard__body"
  }, [(!_vm.leaderboardData) ? _c('ark-preload', {
    staticClass: "ark-leaderboard__loader"
  }) : _vm._e(), _vm._v(" "), (_vm.leaderboardData) ? _c('leaderboard-content', {
    attrs: {
      "leaderboardData": _vm.leaderboardData,
      "chosenPeriod": _vm.chosenPeriod,
      "emptyLeaderboardText": _vm.config.emptyLeaderboardText
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// lib/leaderboard.min.js